<template>
    <div>
        <div v-if="loading">
                        <div style="position: fixed; top:0; bottom:0; width:100%;background-color:#efefef;opacity:0.4;z-index:99;margin: 0 auto;text-align:center;">
            <img style="position:relative;top:45%;opacity:1;z-index:100;" src="./../assets/images/loader.gif" alt="" />
            </div>
        </div>
<div class="profile-sec">
        <div class="container-fluid">
            <div class="row">
                <div class="col-md-2 zero col-xs-12">
                    <sidebar/>
                </div>
                <div class="col-md-10 col-xs-12">
                    <div class="profl-sec">
                        <div class="h3-title">
                            <h3>Contractor Profile</h3>
                        </div>
      <div class="tab-content">
          <div class="tab-pane active" id="home-v" v-for="bulkManpower in bulkManpowers" :key="bulkManpower.id">
            <div class="col-md-4">
              <div class="cnd-main">
                <div class="cad-img">
                  <img :src='imagePath+bulkManpower.logo' class="img-responsive">
                </div>
                
              </div>
            </div>
            <div class="col-md-8">
              <div >
        <div class="packs-contant">
          <h3 style="margin-top:0;">{{ bulkManpower.name }}</h3>
          <ul>
                    <li><i class="fa fa-mobile"></i> {{ bulkManpower.contact_no }}</li>
                    <li><i class="fa fa-envelope"></i> {{ bulkManpower.email }}</li>
                  </ul>
          <table class="table table-bordered">
            <tbody>
              <tr>
                <td colspan="2" style="background-color:#5cb85c;color: #fff;">About Me</td>
              </tr>
             <tr >
              <td colspan="2">{{ bulkManpower.about }}</td>
            </tr>
             <tr>
                <td colspan="2" style="background-color:#5cb85c;color: #fff;">Address</td>
              </tr>
              <tr >
              <td colspan="2">{{ bulkManpower.address }}</td>
            </tr>
            <tr>
              <th>City</th>
              <td>{{ bulkManpower.city}} </td>
            </tr>
            
            <tr> 
              <th>State</th>
              <td>{{ bulkManpower.state}}</td>
            </tr>
            <tr> 
              <th>Pincode</th>
              <td>{{ bulkManpower.pin_code }}</td>
            </tr>
            <tr> 
              <th>Country</th>
              <td>{{ bulkManpower.country.name }}</td>
            </tr>
          
              <tr>
                <td colspan="2" style="background-color:#5cb85c;color: #fff;">Team Capacity</td>
              </tr>
             <tr >
              <td><b>Team Capacity</b> </td>
              <td><b>{{ bulkManpower.team_capacity }}</b></td>
            </tr>

            <tr v-for='labour in JSON.parse(bulkManpower.labour_categorywise)' :key="labour.category">
              <td>{{ labour.category}} </td>
                    <td>{{ labour.capacity}}</td>
            </tr>
            
            
            </tbody>
          </table>
        </div>
      </div>
            </div>
          </div>
        </div>
      </div>
      </div>
    </div>
  </div>
</div>

    </div>
</template>

<script>
  import SideBar from './SideBar.vue';

export default {
  components: {
        'sidebar': SideBar
    },
 props: ['details'],
    data() {
        return {
            bulkManpowers: [],
            imagePath: process.env.VUE_APP_API_URL,
            showInfo:false,
            showInfoButton:true
        }
    },
    created() {
        this.axios
            .get(process.env.VUE_APP_API_URL+'api/my-bulk-manpower-work-details?id=12')
            .then(response => {
                this.bulkManpowers = response.data.bulk_manpower_details;
            });
    }
}
</script>